// extracted by mini-css-extract-plugin
export default {"container":"Specialities_container__-2VE2"};